import { Injectable } from '@angular/core';
import { RegionSelectIntl } from '@knorr-bremse-portals/ngx-components/components/region-select';

@Injectable({providedIn: 'root'})
export class LocalRegionSelectIntl extends RegionSelectIntl {

  public override modalHeading = $localize `:region select modal heading@@3874223312167776282:Country/Region and language selection`;
  public override regionSelectLabel = $localize `:region select region select label@@3170237811836418468:Country/Region`;
  public override languageSelectLabel = $localize `:region select language select label@@2826581353496868063:Language`;
  public override submitButtonLabel = $localize `:region select submit button label@@6962699013778688473:Continue`;
  public override openButtonLabel = $localize `:region select open button label@@8339154900515271716:Open country/region and language selection`;
  public override closeButtonLabel = $localize `:region select close button label@@7819314041543176992:Close`;
  public override languageIsRequiredError = $localize `:region select language is required error@@2175784236523326802:Required field`;
  public override noSelectedLanguageOptionLabel = $localize `:region select empty language option label@@3256590211420252677:Choose a language`;

}
